module.exports = __webpack_public_path__ + "static/media/STFU2.42f9be8d.png";